module.exports = __webpack_public_path__ + "static/scale-model-of-valmont-bike-park-in-boulder-colorado-5ae144402369382d37458677c8f89a52.png";